import {
  setComparisonAlbumsFailed,
  setComparisonAlbumsLoading,
  setComparisonAlbumsSucceed,
} from '../../actions/comparisonAlbums';
import { getComparisonAlbums as getComparisonAlbumsService } from '../../services/propertyComparison';
import { EComparisonAlbumsStatus } from '../../types/comparisonAlbums';
import { type TThunkAction } from '../../types/redux';

export const getComparisonAlbums =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const { user, comparisonAlbums } = getState();

    if (!user.isAuthenticated) {
      return;
    }

    if (comparisonAlbums.status === EComparisonAlbumsStatus.Loading) {
      return;
    }

    dispatch(setComparisonAlbumsLoading());

    const albums = await getComparisonAlbumsService({ httpApi, logger });

    if (!albums) {
      dispatch(setComparisonAlbumsFailed());

      return;
    }

    dispatch(setComparisonAlbumsSucceed(albums));
  };
